export default __webpack_public_path__ + "static/media/article_1.a.74d5694e.png";